import { Injectable } from '@angular/core';
import { Order, QueryEntity } from '@datorama/akita';
import {
	compareEntities,
	compareEntity,
	isEquals,
} from '@lycoris-nubila/ngx-lycoris';
import { isNil, reject, uniqBy } from 'lodash-es';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

import { Phase } from 'phase/phase';
import { PhaseState, PhaseStore } from 'phase/phase.store';
import { PhaseRepositoryPort } from 'phase/port/phase-repository.port';

import { CacheObservable } from '../../app-decorators';

@Injectable()
export class PhaseRepositoryAdapter
	extends QueryEntity<PhaseState>
	implements PhaseRepositoryPort
{
	constructor(protected store: PhaseStore) {
		super(store);
	}

	@CacheObservable()
	public observePhaseById(id: string): Observable<Phase> {
		return this.selectEntity(id).pipe(
			map((document) => this.store.asEntity(document)),
			distinctUntilChanged(compareEntity),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}

	@CacheObservable()
	public observePhasesByOrganizationId(
		organizationId: string
	): Observable<Phase[]> {
		return this.selectAll({
			filterBy: (entity) => isEquals(entity.organizationId, organizationId),
			sortByOrder: Order.ASC,
			sortBy: 'position',
		}).pipe(
			map((documents) =>
				documents.map((document) => this.store.asEntity(document))
			),
			distinctUntilChanged(compareEntities),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}

	public async savePhases(entities: Phase[]): Promise<void> {
		this.store.upsertMany(
			uniqBy(
				reject(entities, isNil).map((e) => this.store.asDocument(e)),
				'id'
			)
		);
	}
}
